import React, { Component } from 'react'
import './styles/dropdownButton.scss'
import Button from './Button'

class DropdownButton extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isOpen: false,
        }
        this.dropdownRef = React.createRef()
    }

    componentDidMount() {
        document.addEventListener('mousedown', this.handleClickOutside)
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside)
    }

    handleClickOutside = (event) => {
        if (this.dropdownRef.current && !this.dropdownRef.current.contains(event.target)) {
            this.setState({ isOpen: false })
        }
    }

    toggleDropdown = () => {
        this.setState((prevState) => ({ isOpen: !prevState.isOpen }))
    }

    handleClick = (onClick) => {
        this.setState({ isOpen: false })
        if (typeof onClick === 'function') onClick()
    }

    renderOption = (o, idx) => {
        switch (o.type) {
            case 'button':
                return (
                    <Button
                        key={`menu_${idx}`}
                        cssClass={`dropdown-button-item ${o.cssClass || ''}`}
                        onClick={() => this.handleClick(o.onClick)}
                        icon={o.icon}
                        style={o.style}
                    >
                        {o.label}
                    </Button>
                )
            default:
                return null
        }
    }

    render() {
        const { isOpen } = this.state
        const {
            options, label, hasChevronIcon, style,
        } = this.props

        return (
            <div className="dropdown-button-container" ref={this.dropdownRef} style={style}>
                <button
                    type="button"
                    className={`dropdown-button ${isOpen ? 'open' : ''}`}
                    onClick={this.toggleDropdown}
                >
                    <span className="dropdown-button-text">{label}</span>
                    {hasChevronIcon && (
                        <div className="chevron-container">
                            <i className={`fas fa-chevron-${isOpen ? 'up' : 'down'} dropdown-chevron`} />
                        </div>
                    )}
                </button>
                <div className={`dropdown-button-menu ${isOpen ? 'open' : ''}`}>
                    {options.map((o, idx) => (
                        this.renderOption(o, idx)
                    ))}
                </div>
            </div>
        )
    }
}

export default DropdownButton
